import React from 'react';
import { useAgreementTemplateQuery } from '@uplift/queries';
import { CollaborativeAgreementExpired } from '@uplift/api';
import { ErrorOutline } from '@mui/icons-material';
import { CalendarDateService } from '@uplift/services';
import { DateFormats } from '@uplift/constants';
import { DocumentListItemRow } from './DocumentListItemRow';


export const CollaborativeAgreementExpiredListItem: React.VFC<{
  document: CollaborativeAgreementExpired;
  onClick: () => void;
  selected: boolean;
}> = ({
  document,
  onClick,
  selected,
}) => {
  const { data: template } = useAgreementTemplateQuery(document.agreementTemplateId);
  const expiredAt = CalendarDateService.date(document.expiredAt, DateFormats.ISO_DATE).format(DateFormats['MMM D, YYYY']);

  return (
    <DocumentListItemRow
      name={template.name}
      status={`Expired ${expiredAt}`}
      statusColor="error"
      icon={<ErrorOutline />}
      onClick={onClick}
      selected={selected}
    />
  );
};
